import { call, put, takeLatest, takeLeading, select, takeEvery } from 'redux-saga/effects';
import {
  GET_USER,
  GET_USER_CONVERSATIONS_LIST,
  CREATE_NEW_CONVERSATION,
  GET_USER_CONVERSATION,
  UPDATE_CONVERSATION_MESSAGES,
  HIDE_REMOVABLE_MESSAGES,
  GET_INITIAL_STATE,
  PROCESS_PUSHER_MESSAGES,
  PROCESS_CLIENT_MESSAGES,
  UPDATE_SENDING_MESSAGES,
  REMOVE_FROM_SENDING_MESSAGES,
  HANDLE_SENDING_MESSAGES_TO_PUSHER,
  UPDATE_MESSAGE_READ_STATUS,
  UPDATE_MESSAGE_DELIVERED,
  MESSAGE_TYPES,
  PUSHER_EVENT_TYPES,
  SENDING_MESSAGE_TYPE,
  SET_TIME_SPENT,
  SET_ACTIVE_PAGE,
  HANDLE_WIDGET_EVENT,
  TITLEBAR_ALERT_STATUS,
  FETCH_MEETING_SLOTS,
  BOOK_MEETING_SLOT,
  SET_DELAY_FLAG,
  GET_CHANNEL_ID,
  GET_ALL_FILES,
  REMOVE_FROM_CONVERSATION_MESSAGES,
  HANDLE_SENDING_COOKIES_TO_PUSHER,
  GET_RECENT_GIFS, GET_TRENDING_GIFS, GET_SEARCHED_GIFS,
} from './constants';
import { REACT_APP_BASE_URL_FE} from 'config.js';
import { PAGE } from 'common/constants';
import axios from 'axios';
import queryString from 'query-string';
import * as actions from './actions';
import * as selectors from './selectors';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import isSessionActive from 'utils/isSessionActive';
import localStorageTemplates from 'common/local-storage-templates';
import { NATIVE_NOTIFICATION_VARIANT } from './constants';
import { eventTypes } from 'utils/eventTypes';
import isConversationDisabled from 'utils/isConversationDisabled';
import isPopAlerted from 'utils/isPopAlerted';
import {
  saveEventToLocalStorage,
  saveToLocalStorage,
  getFromLocalStorage,
} from 'utils/saveToLocalStorage';
import { WINDOW_POSTMESSAGE_TYPES } from './constants';
import { initiateTitleAlert, abortTitleAlert } from 'utils/triggerTitleNotification';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { postMessageToWindow } from 'utils/index';
export function* getInitialState(sessionTime) {
  const search = window.location.search;
  try {
    const queryParams = yield call(queryString.parse, search);
    const projectKey = queryParams && queryParams.project_key;
    const blogUrl = queryParams && queryParams.blog_url;
    const marketoCookies = queryParams && queryParams.marketo_cookies;
    const hubspotCookies = queryParams && queryParams.hubspot_cookies;
    const pardotCookies = queryParams && queryParams.pardot_cookies;
    const eloquaCookies = queryParams && queryParams.eloqua_cookies;
    const referralUrl = queryParams && queryParams.referral_url;
    const formData = queryParams && queryParams.form_data;
    const elementData = queryParams && queryParams.element_data;
    const simulator = queryParams && queryParams.admin_panel;
    const visitoridentity = queryParams && queryParams.visitoridentity;
    const primaryColor = queryParams && queryParams.primary_color || null;
    const secondaryColor = queryParams && queryParams.secondary_color || null;
    const logoUrl = queryParams && queryParams.logo_url || null;
    const conversationId = queryParams && queryParams.convid || null;
    const locale = queryParams && queryParams.locale || "en";
    const _zitok = queryParams && queryParams._zitok || null;
    
    let lastActiveTime = getFromLocalStorage(localStorageTemplates.widgetLastActiveTime);

    let isActive = false;

    if (simulator) {
      window.simulator = true;
    }

    if (lastActiveTime && lastActiveTime.length > 0) {
      lastActiveTime = parseInt(lastActiveTime);

      if (lastActiveTime !== undefined) {
        isActive = Date.now() - lastActiveTime < sessionTime;
      }
      if (!isActive) {
        localStorage.removeItem(localStorageTemplates.disabledConversation);
        localStorage.removeItem(localStorageTemplates.notificationRead);
        localStorage.removeItem(localStorageTemplates.widgetPopSoundNoti);
      }
      const channelId = getFromLocalStorage(localStorageTemplates.activeChannelId);

      if (!channelId || channelId.length <= 0) {
        isActive = false;
      }
    }

    if (!isActive) {
      localStorage.removeItem(localStorageTemplates.activeChannelId);
    }

    saveToLocalStorage(localStorageTemplates.widgetSessionActive, isActive);

    saveToLocalStorage(localStorageTemplates.widgetLastActiveTime, Date.now());

    yield put(actions.getInitialState.success({ data: queryParams }));
    let response;

    if(locale === 'zh'){
      response = yield call(() => {return axios.request({
        method: "get",
        url: REACT_APP_BASE_URL_FE+"chinese.json",
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Cache-Control': 'max-age=31536000',
        },
      })});
    }
    else if(locale === 'fr'){
      response = yield call(() => {return axios.request({
        method: "get",
        url: REACT_APP_BASE_URL_FE+"french.json",
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Cache-Control': 'max-age=31536000',
        },
      })});
    }
    else if(locale === 'jap'){
      response = yield call(() => {return axios.request({
        method: "get",
        url: REACT_APP_BASE_URL_FE+"japanese.json",
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Cache-Control': 'max-age=31536000',
        },
      })});
    }
    else {
      response = yield call(() => {return axios.request({
        method: "get",
        url: REACT_APP_BASE_URL_FE+"english.json",
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Cache-Control': 'max-age=31536000',
        },
      })});
    }

    if(response && response.data)
      yield put(
          actions.setLanguage(response.data)
      )

    if (projectKey && blogUrl) {
      yield put(
        actions.getUser.start({
          meta: { formData, elementData, marketoCookies, hubspotCookies, pardotCookies, eloquaCookies, referralUrl, visitoridentity, conversationId, logoUrl, primaryColor, secondaryColor, _zitok },
        })
      );
    }

  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    yield put(actions.getInitialState.error(errorMessage));
  }
}

export function* getChannelId({ meta }){
  let { convId, dimBackground, checkSendingMessages } = meta;
  try{
    const { projectKey, userId } = yield select(selectors.makeSelectConfig());
    let isPusherConnected = yield select(selectors.makeSelectIsPusherConnected());

    let headers = {
      Authorization: `Bearer ${projectKey}`
    }
    if (userId) headers.userid = userId;
    const response = yield call(request, {
      method: 'get',
      endpoint: `user/conversation/${convId}`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });

    let data = response && response.data;
    let cid = response && response.data && response.data.channelId;
    if(cid){
      yield put(actions.setCurrentChannel({channelId: cid}));
    }
    if(isPusherConnected){
      yield put(actions.getUserConversation.start({meta: {cid, checkSendingMessages}}));
    }
    if(dimBackground){
      yield put(actions.setActivePage.start(PAGE.DIMMED_CONVO));
    }
    else{
      yield put(actions.setActivePage.start(PAGE.CONVO));
    }
  }
  catch (error) {
    console.log(error);
  }
}

export function* getUser({ meta }) {
  const { marketoCookies, hubspotCookies, pardotCookies, eloquaCookies, referralUrl, visitoridentity, conversationId, logoUrl, primaryColor, secondaryColor, _zitok } = meta;
  let { formData, elementData } = meta;
  try {
    const { blogUrl, projectKey, userId, eventListenerName } = yield select(
      selectors.makeSelectConfig()
    );

    let headers = {
      Authorization: `Bearer ${projectKey}`,
    };
    if (userId) headers.userid = userId;
    if (marketoCookies) headers.marketoCookies = marketoCookies;
    if (hubspotCookies) headers.hubspotCookies = hubspotCookies;
    if (pardotCookies)  headers.pardotCookies = pardotCookies;
    if (eloquaCookies) headers.eloquaCookies = eloquaCookies;
    if (_zitok) headers._zitok = _zitok;

    let params = `url=${encodeURIComponent(blogUrl)}`;
    if (referralUrl && referralUrl.length) {
      params += `&referralUrl=${encodeURIComponent(referralUrl)}`;
    }
    if(conversationId){
      params += `&convid=${conversationId}`;
    }

    if (isSessionActive()) {
      const channelId = getFromLocalStorage(localStorageTemplates.activeChannelId);
      if (channelId && channelId.length > 0) headers.channelId = channelId;
    } else {
      postMessageToWindow(
        {
          type: eventListenerName,
          event: WINDOW_POSTMESSAGE_TYPES.sessionNotActive,
          userId,
        },
        '*'
      );
    }
    formData = formData && JSON.parse(formData);
    elementData = elementData && JSON.parse(elementData);

    if (formData && formData.channelId) headers.channelId = formData.channelId;
    else if(elementData && elementData.channelId) headers.channelId = elementData.channelId;

    if (visitoridentity) headers.visitoridentity = window.atob(decodeURIComponent(visitoridentity));

    const response = yield call(request, {
      method: 'get',
      endpoint: `getuser?${params}`,
      config: {
        headers: headers,
      },
    });

    let data = response && response.data;
    if (data && formData) {
      data = {
        ...data,
        ...(formData && { formTrigger: true }),
        ...(formData.channelId && { channelId: formData.channelId }),
        ...(formData.popupMessage && {
          popupMessage: formData.popupMessage,
        }),
        settings: {
          ...data.settings,
          ...formData.settings,
        },
        ...(formData.user && { user: formData.user }),
        eventType: PUSHER_EVENT_TYPES.popupMessage,
      };
    } else if( data && elementData) {
      data = {
        ...data,
        ...(elementData && {elementTrigger: true}),
        ...(elementData.channelId && {channelId: elementData.channelId}),
        ...(elementData.popupMessage && {popupMessage: elementData.popupMessage}),
        settings: {
          ...data.settings,
          ...elementData.settings
        },
        ...(elementData.user && {user: elementData.user}),
        eventType: PUSHER_EVENT_TYPES.popupMessage,
      }
    }

    const responseUserId = data.user && data.user.id;
    const botName = data.settings && data.settings.bot && data.settings.bot.name;
    const hideCompanyDetailsInWidget = data.settings && data.settings.hideCompanyDetailsInWidget;
    const channelId = data.channelId;
    const forms = data.externalTriggers && data.externalTriggers.forms;
    const elements = data.externalTriggers && data.externalTriggers.elements;
    const formFields = data.externalTriggers && data.externalTriggers.formFields;
    const customCookie = data.trackCustomCookies;

    if (data && data.popupMessage && !window.simulator) {
      initiateTitleAlert({
        senderName: data.settings.bot && data.settings.bot.name,
        event: TITLEBAR_ALERT_STATUS.set,
        type: WINDOW_POSTMESSAGE_TYPES.titleBarAlert,
      });
    }

    if (responseUserId) {
      yield put(actions.setUserId({ userId: responseUserId }));
    }
    if (data.initiateSocketConnection) {
      yield put(actions.setInitiateSocketConnection({InitiateSocketConnection: data.initiateSocketConnection}));
    }
    if(hideCompanyDetailsInWidget) {
      yield put(actions.setHideCompanyDetailsInWidget({ hideCompanyDetailsInWidget }))
    }
    if(botName) {
      yield put(actions.setBotName({ botName }));
    }
    if (channelId) {
      yield put(actions.setCurrentChannel({ channelId: channelId }));
    }
    if (forms && forms.length > 0) {
      yield put(actions.setExternalTriggerForms({ forms }));
    }
    if (elements && elements.length>0){
      yield put(actions.setExternalTriggerElements({ elements }));
    }
    if(formFields && formFields.length >0){
      yield put(actions.setMappedFormFields({formFields}))
    }
    if (!data.subscriptionChannel) {
      console.log('No active conversation in this page');
    }
    if(customCookie && Array.isArray(customCookie) && customCookie.length > 0) {
      yield put(actions.setCustomCookies({customCookies: customCookie}));
    }

    if (channelId && isPopAlerted(channelId)) yield put(actions.setWidgetSoundStatus(false));
    else yield put(actions.setWidgetSoundStatus(data.settings.widgetSound));

    yield put(actions.getUser.success({ data }));
    if(primaryColor) {
      yield put(actions.setPrimaryColor({primaryColor}));
    }
    if(secondaryColor) yield put(actions.setSecondaryColor({secondaryColor}));
    if(logoUrl) yield put(actions.setLogoUrl(logoUrl));
  } catch (error) {
    console.log(error);
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getUser.error(errorMessage));
  }
}

export function* getUserConversationList() {
  try {
    const { projectKey, userId } = yield select(selectors.makeSelectConfig());

    const response = yield call(request, {
      method: 'get',
      endpoint: `user/channels`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });

    const data = response && response.data;
    yield put(actions.getUserConversationsList.success({ data }));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getUserConversationsList.error(errorMessage));
  }
}

export function* getUserConversationStart({ meta }) {
  try {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());
  const { cid, checkSendingMessages } = meta;

    const response = yield call(request, {
      method: 'get',
      endpoint: `user/channels/${cid}`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });

    const data = response && response.data;
    if(data.hideRestartButton === true) yield put(actions.hideRestartButton({hideRestartButton: data.hideRestartButton}));
    else yield put(actions.hideRestartButton({hideRestartButton: false}));
    if (data.messages) data.messages = [...processMessages(data.messages)];
    if (data.prevMessages) data.prevMessages = [...processMessages(data.prevMessages, true)];
    yield put(actions.getUserConversation.success({ data }));

    if (data.unread) yield put(actions.updateMessageReadStatus());

    if (checkSendingMessages) {
      checkSendingMessages({ type: SENDING_MESSAGE_TYPE.message });
    }
    const { showTypingIndicator } = data;
    saveToLocalStorage(localStorageTemplates.activeChannelId, cid);
    yield put(actions.setShowTypingIndicator(showTypingIndicator));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    yield put(actions.getUserConversation.error(errorMessage));
  }
}

function isRemovableElement(message) {
  if (message.type === MESSAGE_TYPES.buttons) return true;
  if (message.type === MESSAGE_TYPES.input.val) return !message.input.disabled;
  if(message.type === MESSAGE_TYPES.calendar) return !message.calendar.hasOwnProperty('booked');
  if(message.type === MESSAGE_TYPES.feedback) return !(message.feedback.isCancellable === false || message.feedback.hasOwnProperty('submitted'));
}

function isReplaceAbleElement(message) {
  if (message.type === MESSAGE_TYPES.feedback) return true;
  if (message.type === MESSAGE_TYPES.calendar) return true;
}

function processMessages(messages , isPreviousMessage) {
  if (!messages) {
    return [];
  }
  const currentPathTimestamp = Date.now();
  const newMessages = messages.map(message => {
    message.timestamp = currentPathTimestamp;
    if (message.text) message.type = MESSAGE_TYPES.text;
    else if (message.event) message.type = MESSAGE_TYPES.event;
    else if (message.attachments && (!Array.isArray(message.attachments) || message.attachments.length > 0)) message.type = MESSAGE_TYPES.attachments;
    else if (message.buttons) message.type = MESSAGE_TYPES.buttons;
    else if (message.input) message.type = MESSAGE_TYPES.input.val;
    else if (message.link) message.type = MESSAGE_TYPES.link;
    else if (message.plainInput) message.type = MESSAGE_TYPES.plainInput;
    else if (message.notification) message.type = MESSAGE_TYPES.notification;
    else if (message.feedback) {
      if (message.feedback && message.feedback.hasOwnProperty('submitted') && !message.feedback.submitted) {
        message.type = MESSAGE_TYPES.event;
        message.event = 'Feedback canceled';
        message.lead = false;
        message.time = Date.now();
        delete message.feedback
      } else {
        message.type = MESSAGE_TYPES.feedback;
        if (isPreviousMessage) message.feedback.isCancellable = false;
      }
    } else if (message.calendar) {
      message.type = MESSAGE_TYPES.calendar;
    }
    if (!message.img) message.img = null;
    return message;
  });
  return newMessages;
}

export function* removeFromConversationMessagesStart({meta}) {
  const id = meta && meta.id && meta.id.id;
  if(!id) return;
  let currentMessages = yield select(selectors.makeSelectConversationMessages());
  currentMessages = currentMessages.filter(message => {
    return message.id !== id;
  });
  yield put(actions.removeFromConversationMessages.success({ messages: currentMessages }));
}

export function* updateConversationMessagesStart({ meta }) {
  const { message } = meta;
  let userConfig = yield select(selectors.makeSelectConfig());
  let isRestartConversation = message && message.text === `@${userConfig.botName}`;
  let currentMessages = yield select(selectors.makeSelectConversationMessages());
  currentMessages = cloneDeep(currentMessages);
  let currentMessage = cloneDeep(message);
  let lastMessage = cloneDeep(currentMessages && currentMessages.length > 0 && currentMessages[currentMessages.length - 1]);
  let isLastMessageFeedback = currentMessages && currentMessages.length > 0 && currentMessages[currentMessages.length - 1].feedback;
  let isLastMessageCalendar = currentMessages && currentMessages.length > 0 && currentMessages[currentMessages.length - 1].calendar;
  if (currentMessage && currentMessage.time) delete currentMessage.time;
  if (lastMessage && lastMessage.time) delete lastMessage.time;

  if (message && message.calendar && message.calendar.key && message.calendar.hasOwnProperty('booked')) {
    currentMessages = currentMessages.map(currentMessage => {
      if (currentMessage.calendar && currentMessage.calendar.key === message.calendar.key) return message;
      return currentMessage;
    });
  } else if (message && message.calendar && message._id) {
    currentMessages = currentMessages.map(currentMessage => {
      if (currentMessage._id === message._id || (currentMessage.calendar && currentMessage.calendar._id === message._id)) return message;
      return currentMessage;
    })

  } else if (message && message.feedback && message._id) {
      currentMessages = currentMessages.map(currentMessage => {
        if (currentMessage._id === message._id || (currentMessage.feedback && currentMessage.feedback._id === message._id)) return message;
        return currentMessage;
      })

  } else if (message && message.feedback && message.feedback.key && message.feedback.hasOwnProperty('submitted')){
    currentMessages = currentMessages.map(currentMessage => {
      if (currentMessage.feedback && currentMessage.feedback.key === message.feedback.key) return message;
      return currentMessage;
    });
  } else if(isRestartConversation && ((isLastMessageFeedback && !isLastMessageFeedback.hasOwnProperty('submitted') ) || (isLastMessageCalendar && !isLastMessageCalendar.hasOwnProperty('booked')))) {
    currentMessages = currentMessages.filter((currentMessage,index) => index !== currentMessages.length - 1);
    if (message) currentMessages.push(message);
  } else if(message && message.attachments && message.id){
      let flag=false;
      currentMessages = currentMessages.map(currentMessage => {
      if(currentMessage.id === message.id) {
        if(typeof message.setProgressBarCompletion === "function"){
          message.setProgressBarCompletion(100);
          setTimeout(() => {
            message.setProgressBarCompletion(0);
          },500)
        }
        flag=true;
        return {...currentMessage, preview: false};
      }
      else return currentMessage;
    })
    if(flag === false){
      currentMessages = currentMessages.filter(message => {
        return !isRemovableElement(message);
      });
      if (message && !isEqual(lastMessage,currentMessage) && !message?.isGif) currentMessages.push(message)
    }
  } else if(message && message.isGif && message.gifs){
      currentMessages.push(message);
  }
  else {
    currentMessages = currentMessages.filter(message => {
      return !isRemovableElement(message);
    });
    if (message && !isEqual(lastMessage,currentMessage)) currentMessages.push(message)
  }
  yield put(actions.updateConversationMessages.success({ messages: currentMessages }));
}

export function* hideRemovableElements(){
  let currentMessages = yield select(selectors.makeSelectConversationMessages());
  currentMessages = currentMessages.filter(message => {
    return !isRemovableElement(message);
  });
  yield put(actions.updateConversationMessages.success({ messages: currentMessages }));
}

export function* createNewConversation() {
  try {
    const { blogUrl, projectKey, userId } = yield select(selectors.makeSelectConfig());
    yield put(actions.setCurrentChannel({ channelId: undefined }));
    yield put(actions.setActivePage.start(PAGE.CONVO));

    const response = yield call(request, {
      method: 'post',
      endpoint: `user/channel/?url=${blogUrl}`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });

    const data = response && response.data;
    yield put(actions.setCurrentChannel({ channelId: data.channelId }));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getUserConversationsList.error(errorMessage));
  }
}

export function* processClientMessages({ meta }) {
  const { data } = meta;
  let currentChannel = yield select(selectors.makeSelectCurrentChannel());
  if(data && data.display && data.channelName){
    if(currentChannel === data.channelName) {
      yield put(actions.clearActiveMessages(true));
      yield put(actions.updateConversationMessages.start({meta: {message: data.display}}));
    }
  }
}

export function* setDelayFlag( flag ) {
  yield put(actions.setDelayFlag(flag));
}

export function* processPusherMessages({ meta }) {
  const {
    data,
    setShowNewMessageNotification,
    setPopup,
    isWindowFocused,
    setNativeNotification,
    formTrigger,
    elementTrigger
  } = meta;
  if(data.hideRestartButton) yield put(actions.hideRestartButton({hideRestartButton: data.hideRestartButton}));
  const eventType = data.eventType || '';
  const currentPage = yield select(selectors.makeSelectCurrentPage());
  let windowFocused = document.hasFocus();
  let currentChannel = yield select(selectors.makeSelectCurrentChannel());
  let isDelayOn = yield select(selectors.makeSelectDelayFlag());
  let serverMessagesQueue = yield select(selectors.makeSelectServerMessagesQueue());
  if(!serverMessagesQueue) serverMessagesQueue = [];
  if(isDelayOn !== false && isDelayOn.time)
  {
    serverMessagesQueue.push({ meta });
    yield put(actions.setServerMessagesQueue(serverMessagesQueue));
    return;
  }
  if ((currentPage !== PAGE.CONVO || currentPage !== PAGE.DIMMED_CONVO || !isWindowFocused.current) && !window.simulator) {
    initiateTitleAlert({
      senderName: data && data.sender && data.sender.name,
      event: TITLEBAR_ALERT_STATUS.set,
      type: WINDOW_POSTMESSAGE_TYPES.titleBarAlert,
    });
  }

  if (!windowFocused) {
    isWindowFocused.current = false;
  }
  switch (eventType) {
    case PUSHER_EVENT_TYPES.newMessage:
      let totalNotification = yield select(selectors.makeSelectNotificationRead());
      yield put(actions.setNotificationRead(parseInt(totalNotification) + 1));
      saveToLocalStorage(localStorageTemplates.notificationRead, parseInt(totalNotification) + 1);
      saveToLocalStorage('pathEvents', JSON.stringify([]));
      yield put(actions.updateMessageDelivered());
      yield put(actions.setPopupToNotificationMessage({ message: '' }));
      if (
        currentPage === '' ||
        currentPage === PAGE.LAUNCHER ||
        currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE
      ) {
        if (data.messages && data.messages.length && data.channelId) {
          let lastMessage = {};
          const processedMessages = [...processMessages(data.messages)];
          let isEventMessage =
            processedMessages.length === 1 && processMessages.type === MESSAGE_TYPES.event;
          for (let msg of processedMessages) {
            if (msg.type === MESSAGE_TYPES.text) {
              lastMessage.text = msg.text;
              lastMessage.mentions = msg.mentions;
              break;
            } else if (msg.type === MESSAGE_TYPES.attachments) {
              lastMessage.attachments = msg.attachments;
            }
          }

          if (!isEventMessage && data.sender) {
            if (
              data.popupMessage &&
              data.popupMessage.message &&
              data.popupMessage.message.length > 0
            ) {
              setPopup({
                popupMessage: data.popupMessage.message,
                mentions: lastMessage.mentions,
                sender: data.sender || { name: 'Agent' },
              });
              yield put(actions.setActivePage.start(PAGE.POPUP_NORMAL));
            } else if (
              data.botActive &&
              data.sender &&
              data.sender.id &&
              data.sender.id === 'bot'
            ) {
              if(currentPage !== PAGE.POPUP_NORMAL && currentPage !== PAGE.POPUP_NEW_MESSAGE && currentPage !== PAGE.POPUP_CONNECTED)
                yield put(actions.setActivePage.start(PAGE.LAUNCHER));
            } else {
              setPopup({
                popupMessage: lastMessage.text || lastMessage.attachments,
                mentions: lastMessage.mentions,
                sender: data.sender || { name: 'Agent' },
              });

              let newAgentMessageList = [
                ...(yield select(selectors.makeSelectAgentNewMessageList())),
                lastMessage.text || lastMessage.attachments,
              ];
              yield put(actions.setAgentMessageList(newAgentMessageList));

              yield put(actions.setActivePage.start(PAGE.POPUP_NEW_MESSAGE));
            }

            yield put(actions.setCurrentChannel({ channelId: data.channelId }));
          }
        }
      } else if (currentChannel === data.channelId) {
        const processedMessages = [...processMessages(data.messages)];

        if (data.end === true && !data.botActive) {
          //Message from agent add directly to message array
          if (data.members) {
            let conversationData = {
              ...(yield select(selectors.makeSelectCurrentUserConversation())),
            };
            conversationData.members = data.members;
            conversationData.end = data.hasOwnProperty('end') ? data.end : true;
            conversationData.input = data.hasOwnProperty('input') ? data.input : true;
            conversationData.botActive = data.hasOwnProperty('botActive')
              ? data.botActive
              : conversationData.botActive;
            if(data.category) conversationData.category = data.category;
            if(data.keyValues) conversationData.keyValues = data.keyValues;
            conversationData.messageTimestamp = data.messageTimestamp;
            yield put(actions.setUserConversationData({ data: { ...conversationData } }));
          }
          if (setNativeNotification) {
            setNativeNotification({
              variant: NATIVE_NOTIFICATION_VARIANT.success,
              message: null,
            });
          }
          for (let i = 0; i < processedMessages.length; i++) {
            let payload = {};
            payload.img = data.sender ? data.sender.img || null : null;
            payload.name = data.sender ? data.sender.name || 'Agent' : 'Agent';
            payload.lead = false;
            payload.time = Date.now();
            payload.type = processedMessages[i].type;
            if(processedMessages[i] && processedMessages[i].attachments){
              let userConfig = yield select(selectors.makeSelectConfig());
              if(Array.isArray(processedMessages[i].attachments) && processedMessages[i].attachments[0].isGiphy){
                const event = {
                  eventType: eventTypes.GIF_SHOWN,
                  timestamp: Date.now(),
                  url: userConfig.blogUrl,
                  props: {
                    channelId: currentChannel,
                  },
                };
                saveEventToLocalStorage(event);
              }
            }
            switch (processedMessages[i].type) {
              case MESSAGE_TYPES.text:
                payload.text = processedMessages[i].text;
                payload.mentions = processedMessages[i].mentions;
                payload.category = processedMessages[i].category;
                payload.keyValues = processedMessages[i].keyValues;
                break;
              case MESSAGE_TYPES.feedback:
                payload.feedback = processedMessages[i].feedback;
                payload.feedback.isCancellable = false;
                payload.feedback._id = processedMessages[i]._id;
                break;
              // case MESSAGE_TYPES.calendar:
              //   payload.calendar = processedMessages[i].calendar;
              //   payload.calendar._id = processedMessages[i]._id;
              //   break;
              case MESSAGE_TYPES.event:
                payload.event = processedMessages[i].event;
                payload.category = processedMessages[i].category;
                payload.keyValues = processedMessages[i].keyValues;
                break;
              case MESSAGE_TYPES.attachments:
                payload.attachments = processedMessages[i].attachments;
                break;
              default:
                break;
            }

            if (payload.text || payload.event || payload.feedback || payload.attachments) {
              yield put(actions.clearActiveMessages(true));
              yield put(actions.updateConversationMessages.start({ meta: { message: payload } }));
            }
          }
          yield put(actions.clearBotActivePath(true));
          // reset network delay and typing state variables if were true
          const isTyping = yield select(selectors.makeSelectIsTyping());
          const showTypingIndicator = yield select(selectors.makeSelectShowTypingIndicator());
          if(isTyping) yield put(actions.setShowTyping(false));
          if (showTypingIndicator) yield put(actions.setShowTypingIndicator(false));
          yield put(actions.resetNetworkDelay());
        } else {
          // bot path
          let conversationData = {
            ...(yield select(selectors.makeSelectCurrentUserConversation())),
          };
          if (!conversationData.messages) {
            conversationData.messages = [];
          }
          if (data.sender) conversationData.sender = data.sender;
          if (data.members) conversationData.members = data.members;

          conversationData.end = data.hasOwnProperty('end') ? data.end : true;
          conversationData.input = data.hasOwnProperty('input') ? data.input : true;
          conversationData.botActive = data.hasOwnProperty('botActive')
            ? data.botActive
            : conversationData.botActive;
          conversationData.messageTimestamp = data.messageTimestamp;
          if(data.category) conversationData.category = data.category;
          if(data.keyValues) conversationData.keyValues = data.keyValues;

          // setting typing indicator to false
          const { showTypingIndicator } = data;
          yield put(actions.setShowTyping(false));
          yield put(actions.setShowTypingIndicator(showTypingIndicator));

          const networkDelay = yield select(selectors.makeSelectNetworkDelay());
          if (conversationData.end) {
            yield put(actions.resetNetworkDelay());
          } else {
            yield put(actions.setServerResponseTime(Date.now()));
            if (data.messages) {
              data.messages = data.messages.map(message => {
                const { sentTime } = networkDelay;
                let { pause } = message;
                if (pause && pause > 0) {
                  if (sentTime) {
                    const delayValue = Date.now() - sentTime;
                    if (delayValue > 0) {
                      pause = pause - delayValue;
                    }
                  }
                  return {
                    ...message,
                    pause: pause > 0 ? pause : 0,
                  };
                } else {
                  return message;
                }
              });
            }
          }
          conversationData.messages = data.messages ? [...processMessages(data.messages)] : [];
          yield put(actions.setUserConversationData({ data: { ...conversationData } }));
        }

        if (windowFocused) {
          yield put(actions.updateMessageReadStatus());
        } else {
          // new unread message
          yield put(actions.setIsMessageUnread(true));
        }
      } else {
        setShowNewMessageNotification(true);
      }
      break;
    case PUSHER_EVENT_TYPES.popupMessage:
      if (isConversationDisabled(currentChannel)) {
        let totalNotification = yield select(selectors.makeSelectNotificationRead());
        yield put(actions.setNotificationRead(parseInt(totalNotification) + 1));
        saveToLocalStorage(localStorageTemplates.notificationRead, parseInt(totalNotification) + 1);
      }
      if (
        currentPage === '' ||
        currentPage === PAGE.LAUNCHER ||
        currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE
      ) {
        setPopup({
          popupMessage: data.popupMessage && data.popupMessage.message,
          sender: data.sender,
        });
        yield put(actions.setCurrentChannel({ channelId: data.channelId }));
        let disabledConversations = JSON.parse(
          getFromLocalStorage(localStorageTemplates.disabledConversations) || '[]'
        );
        if ((formTrigger || elementTrigger) && !disabledConversations.includes(data.channelId)) {
          yield put(actions.setActivePage.start(PAGE.CONVO));
        }
        else {
          yield put(actions.setActivePage.start(PAGE.POPUP_NORMAL));
        }
        const userData = yield select(selectors.makeSelectCurrentUser());
        if (data.user) {
          yield put(
            actions.getUser.success({
              data: {
                ...userData,
                ...(data.popupMessage && { popupMessage: data.popupMessage }),
                user: { ...userData.user, ...data.user },
              },
            })
          );
        }
      }
      if (data.popupMessage && data.popupMessage.info) {
        yield put(
          actions.setPopupToNotificationMessage({ message: data.popupMessage.message || '' })
        );
      }
      break;
    case PUSHER_EVENT_TYPES.appUserConnected:
      if (isConversationDisabled(currentChannel)) {
        let totalNotification = yield select(selectors.makeSelectNotificationRead());
        yield put(actions.setNotificationRead(parseInt(totalNotification) + 1));
        saveToLocalStorage(localStorageTemplates.notificationRead, parseInt(totalNotification) + 1);
      }
      saveToLocalStorage('pathEvents', JSON.stringify([]));
      let userConfig = yield select(selectors.makeSelectConfig());
      saveEventToLocalStorage({
        eventType: eventTypes.AGENT_CONNECTED,
        timestamp: Date.now(),
        url: userConfig && userConfig.blogUrl,
        props: {
          channelId: data.channelId,
          agentId: data.sender && data.sender.id,
        },
      });
      yield put(actions.setAgent({ agent: data.sender }));
      if (
        currentPage === '' ||
        currentPage === PAGE.LAUNCHER ||
        currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE
      ) {
        setPopup({
          popupMessage: data.popupMessage.message,
          sender: data.sender,
        });
        yield put(actions.setCurrentChannel({ channelId: data.channelId }));
        saveToLocalStorage(localStorageTemplates.activeChannelId, data.channelId);
        yield put(actions.setActivePage.start(PAGE.POPUP_CONNECTED));
      }
      if (data.popupMessage.info) {
        yield put(
          actions.setPopupToNotificationMessage({ message: data.popupMessage.message || '' })
        );
      }

      let conversationData = {
        ...(yield select(selectors.makeSelectCurrentUserConversation())),
      };

      if (data.members) {
        conversationData.members = data.members;
      } else {
        conversationData.members = [];
      }
      conversationData.botActive = false;
      conversationData.input = true;

      yield put(actions.setUserConversationData({ data: { ...conversationData } }));

      yield put(actions.clearActiveMessages(true));
      yield put(actions.updateConversationMessages.start({ meta: {} }));
      yield put(actions.clearBotActivePath(true));
      yield put(actions.resetNetworkDelay());

      break;
    default:
      break;
  }
};

export function* removeFromSendingMessagesStart({ meta }) {
  const { message } = meta;
  const sendingMessages = [...(yield select(selectors.makeSelectSendingMessages()))];

  const updatedSendingMessages = sendingMessages.filter(msg => message.time !== msg.time);
  yield put(actions.updateSendingMessages.success({ data: [...updatedSendingMessages] }));
  yield put(actions.updateConversationMessages.start({ meta: { message } }));

}

export function* updateSendingMessagesStart({ meta }) {
  const { message } = meta;
  let sendingMessages = yield select(selectors.makeSelectSendingMessages());
  const mutableCopy = cloneDeep(sendingMessages);
  mutableCopy.push(message);
  sendingMessages = mutableCopy;
  yield put(actions.updateSendingMessages.success({ data: [...sendingMessages] }));
}

const delay = (ms) => new Promise(res => setTimeout(res, ms))

export function* sendToPusher({ meta }) {
  const { pusher, subscriptionChannel, data, msg } = meta;
  let isPusherConnected = yield select(selectors.makeSelectIsPusherConnected());
  let maxTries = 60;
  while(!isPusherConnected && maxTries>0) {
    yield delay(1000);
    isPusherConnected = yield select(selectors.makeSelectIsPusherConnected());
    maxTries--;
  }
  if(!isPusherConnected){
    return;
  }
  let triggered = pusher.channel(subscriptionChannel).trigger('client-widget-message', data);
  if (triggered) {
    if (msg) {
      yield put(actions.removeFromSendingMessages({meta: {message: msg}}));
    }
  }
}

export function* handleSendingCookiesToPusher({ meta }){
  const { pusher, data } = meta;
  const { userId } = yield select(selectors.makeSelectConfig());
  const currentChannel = yield select(selectors.makeSelectCurrentChannel());
  const subscriptionChannel = yield select(selectors.makeSelectSubscriptionChannel());
  const { session } = yield select(selectors.makeSelectCurrentUser());

  let CookieData = { senderId: userId, channelName: currentChannel, trackedCookies: data.data.customCookies, sessionId: session};
  yield call(sendToPusher, {
    meta: { pusher, subscriptionChannel, data: CookieData, msg: null},
  });
}

// sending message to pusher for bot and non-bot convo
export function* handleSendingMessagesToPusher({ meta }) {
  const { botName } = yield select(selectors.makeSelectConfig());
  const { pusher, data } = meta;
  const subscriptionChannel = yield select(selectors.makeSelectSubscriptionChannel());
  const sendingMessages = yield select(selectors.makeSelectSendingMessages());
  const { userId } = yield select(selectors.makeSelectConfig());
  const currentChannel = yield select(selectors.makeSelectCurrentChannel());
  const { session } = yield select(selectors.makeSelectCurrentUser());

  switch (data.type) {
    case SENDING_MESSAGE_TYPE.bot:
      yield call(sendToPusher, {
        meta: { pusher, subscriptionChannel, data: {...data.data, sessionId: session}, msg: null },
      });
      const showTypingIndicator = yield select(selectors.makeSelectShowTypingIndicator());
      if (!data.isCalendarCancel) yield put(actions.setShowTyping(showTypingIndicator));
      if(showTypingIndicator) yield put(actions.setClientSentTime(Date.now()));
      break;
    case SENDING_MESSAGE_TYPE.message:
      for (let msg of sendingMessages) {
        if (msg.text) {
          let display = data && data.data && data.data.display;
          let newData = { senderId: userId, channelName: currentChannel, message: { text: msg.text }, display, sessionId: session};
          yield call(sendToPusher, { meta: { pusher, subscriptionChannel, data: newData, msg } });
          if (msg.text.trim() === `@${botName}`) yield put(actions.setClientSentTime(Date.now()));
        }
        else if(msg.attachments){
          let display = data && data.data && data.data.display;
          let newData = { senderId: userId, channelName: currentChannel, attachment: { assemblyUrl: msg.attachments.assemblyUrl }, display, sessionId: session};
          yield call(sendToPusher, { meta: { pusher, subscriptionChannel, data: newData, msg } });
        }
        else if(msg.gif){
          let display = data && data.data && data.data.display;
          let newData = { senderId: userId, channelName: currentChannel, gif: [msg.gif], sessionId: session};
          yield call(sendToPusher, { meta: { pusher, subscriptionChannel, data: newData, msg } });
        }
        else {
          continue;
        }
      }
      break;
    case SENDING_MESSAGE_TYPE.cookies:
      let CookieData = { senderId: userId, channelName: currentChannel, trackedCookies: data.data.customCookies, sessionId: session};
      yield call(sendToPusher, {
        meta: { pusher, subscriptionChannel, data: CookieData, msg: null},
      });
      break;
    default:
      break;
  }
}

export function* updateMessageReadStatus() {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());

  const cid = yield select(selectors.makeSelectCurrentChannel());

  try {
    yield call(request, {
      method: 'post',
      endpoint: `user/channels/${cid}/read`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });
  } catch (error) {
    console.log(error);
  }
}

export function* updateMessageDelivered() {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());

  const cid = yield select(selectors.makeSelectCurrentChannel());

  try {
    yield call(request, {
      method: 'post',
      endpoint: `user/channels/${cid}/delivered`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });
  } catch (error) {
    console.log(error);
  }
}

export function* setTimeSpent({ meta, payload }) {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());
  const { session } = yield select(selectors.makeSelectCurrentUser());
  const { timeDiff } = payload;
  let events = JSON.parse(getFromLocalStorage('events') || '[]');
  if (projectKey && session && session.id && userId) {
    try {
      if (timeDiff > 0 && !window.simulator) {
        saveToLocalStorage('events', JSON.stringify([]));
        // if (isDebugEvent) saveToLocalStorage('insentStackTrace', JSON.stringify([]));
        const data = { timeSpent: timeDiff, events };
        // saveToLocalStorage('insentTimeSpentTimeStamp', Date.now());
        const response = yield call(request, {
          method: 'post',
          endpoint: `user/pageVisit/spentTime/${session.id}`,
          config: {
            headers: {
              Authorization: `Bearer ${projectKey}`,
              userId,
            },
            data,
          },
        });
        if (response.status === 200) {
          yield put(actions.setTimeSpent.success());
        }
      }
    } catch (error) {
      console.log(error);
      if (!window.simulator) {
        saveToLocalStorage('events', JSON.stringify(events));
        yield put(actions.setTimeSpent.error(error));
      }
    }
  }
}

export function* setActivePage({ meta }) {
  const { page } = meta;
  const currentChannel = yield select(selectors.makeSelectCurrentChannel());
  const currentPage = yield select(selectors.makeSelectCurrentPage());
  const { eventListenerName } = yield select(selectors.makeSelectConfig());

  if (page === PAGE.CONVO || page === PAGE.DIMMED_CONVO) {
    abortTitleAlert({
      event: TITLEBAR_ALERT_STATUS.clear,
      type: WINDOW_POSTMESSAGE_TYPES.titleBarAlert,
    });
  }


  if (!isConversationDisabled(currentChannel)) {
    yield put(actions.setActivePage.success(page));
  } else if (
    !currentPage ||
    currentPage.length > 0 ||
    currentPage === PAGE.POPUP_NORMAL ||
    currentPage === PAGE.POPUP_CONNECTED ||
    currentPage === PAGE.POPUP_NEW_MESSAGE
  ) {
    yield put(actions.setActivePage.success(PAGE.LAUNCHER));
  }
  let eventType = '';
  if (page === PAGE.CONVO || page === PAGE.DIMMED_CONVO) {
    eventType = 'onExpand';
  } else if (page === PAGE.LAUNCHER && (currentPage != '' || currentPage === undefined)) {
    eventType = 'onMinimize';
  }
  if (eventType && eventType.length > 0) {
    postMessageToWindow(
      {
        type: eventListenerName,
        event: WINDOW_POSTMESSAGE_TYPES.widgetEvent,
        eventType,
      },
      '*'
    );
  }

  if(page == PAGE.DIMMED_CONVO)
  {
    postMessageToWindow(
  {
      type: eventListenerName,
      event: 'dimBackground',
     },
   '*'
   );
  }
}

export function* handleWidgetEvent({ meta }) {
  const { event } = meta;
  const currentPage = yield select(selectors.makeSelectCurrentPage());

  switch (event) {
    case 'widget-expand':
      if (
        currentPage === PAGE.LAUNCHER ||
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE ||
        currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.DIMMED_CONVO
      ) {
        yield put(actions.setActivePage.start(PAGE.CONVO));
      }
      break;
    case 'widget-minimize':
      if (
        currentPage === PAGE.POPUP_CONNECTED ||
        currentPage === PAGE.POPUP_NEW_MESSAGE ||
        currentPage === PAGE.POPUP_NORMAL ||
        currentPage === PAGE.HOME ||
        currentPage === PAGE.CONVO ||
        currentPage === PAGE.DIMMED_CONVO
      ) {
        yield put(actions.setNotificationRead(1));
        saveToLocalStorage(localStorageTemplates.notificationRead, 1);
        yield put(actions.setActivePage.start(PAGE.LAUNCHER));
      }
      break;
  }
}


export function* fetchMeetingSlotsSaga({meta }) {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());
  const { startTime, endTime, duration, participants,offset,handleNewSlotResponse } = meta;
  try {
    const response = yield call(request, {
      method: 'get',
      endpoint: `user/meeting/slots?startTime=${startTime}&endTime=${endTime}&offset=${offset}&duration=${duration}&participants=${encodeURI(JSON.stringify(participants))}`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      },
    });
    handleNewSlotResponse(response.data);
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    handleNewSlotResponse({err: true, errorMessage})
  }
}

export function* bookMeetingSlotsSaga({ payload, meta }) {
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());
  const  { handleBookMeeting} = meta;
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: `user/meeting/book`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
        data: {
          ...payload
        },
      },
    });
    handleBookMeeting(response.data);
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    handleBookMeeting({err: true, errorMessage});
  }
}

export function* getAllFiles({meta}){
  const { projectKey, userId } = yield select(selectors.makeSelectConfig());
  try{
    const response = yield call(request, {
      method: 'get',
      endpoint: `user/attachments/50`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
          userId,
        },
      }
    });
    if(response && response.data){
      yield put(actions.setUserAttachments({attachments: response.data.visitorAttachments}));
    }
  }
  catch(error){
    console.log(error);
  }
}

export function* getRecentGifsSaga({ metadata }) {
  try {
    const { projectKey, userId } = yield select(selectors.makeSelectConfig());
    const { isInbox, fid } = metadata;
    const response = yield call(request, {
      method: 'get',
      endpoint: isInbox ? 'app/inbox/recentGifs' : `app/flow/${fid}/recentGifs`,
      config: {
        headers: {
          Authorization: `Bearer ${projectKey}`,
        },
      },
    });
    const { data } = response || {};
    const recentGifs = Array.isArray(data?.recentGifs) ? data.recentGifs : [];
    yield put(actions.getRecentGifs.success({ data: recentGifs }));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getRecentGifs.error());
  }
}

const transformGifSchema = data => {
  data.data =
      data?.data?.map?.(gif => ({
        id: gif.id,
        name: gif.title,
        original: {
          ...gif.images?.downsized_medium,
          url: gif.images?.downsized_medium.url?.split('?')[0],
        },
        previewGif: {
          height: gif.images?.fixed_width?.height,
          width: gif.images?.fixed_width?.width,
          size: gif.images?.fixed_width?.size,
          url: gif.images?.fixed_width?.url?.split('?')[0],
        },
        previewStill: {
          ...gif.images?.fixed_width_still,
          url: gif.images?.fixed_width_still?.url?.split('?')[0],
        },
      })) || [];
  delete data?.meta;
  return data;
};

const fetchGifs = async ({ apiKey, endpoint, rating, limit, offset, q }) => {
  try {
    const gifs = await axios.request({
      method: 'get',
      url: `https://api.giphy.com/v1/gifs/${endpoint}?api_key=${apiKey}&rating=${rating}&limit=${limit}&offset=${offset}${
          q ? `&q=${q}` : ''
      }`,
    });
    return gifs;
  } catch (error) {
    throw error;
  }
};

export function* getTrendingGifsSaga({ meta }) {
  try {
    const response = yield call(fetchGifs, meta);
    const data = transformGifSchema(response.data);
    yield put(actions.getTrendingGifs.success({ data }));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getTrendingGifs.error());
  }
}

export function* getSearchedGifsSaga({ meta }) {
  try {
    const response = yield call(fetchGifs, meta);
    const data = transformGifSchema(response.data);
    yield put(actions.getSearchedGifs.success({ meta, data }));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    yield put(actions.getSearchedGifs.error());
  }
}

export default function* appSaga() {
  yield takeLatest(GET_INITIAL_STATE.START, getInitialState);
  yield takeLatest(GET_CHANNEL_ID.START, getChannelId);
  yield takeLatest(GET_USER.START, getUser);
  yield takeLatest(GET_USER_CONVERSATIONS_LIST.START, getUserConversationList);
  yield takeLatest(GET_USER_CONVERSATION.START, getUserConversationStart);
  yield takeEvery(UPDATE_CONVERSATION_MESSAGES.START, updateConversationMessagesStart);
  yield takeLatest(REMOVE_FROM_CONVERSATION_MESSAGES.START, removeFromConversationMessagesStart);
  yield takeLatest(HIDE_REMOVABLE_MESSAGES.START, hideRemovableElements);
  yield takeLatest(CREATE_NEW_CONVERSATION.START, createNewConversation);
  yield takeEvery(PROCESS_PUSHER_MESSAGES, processPusherMessages);
  yield takeEvery(PROCESS_CLIENT_MESSAGES, processClientMessages);
  yield takeLatest(UPDATE_SENDING_MESSAGES.START, updateSendingMessagesStart);
  yield takeLatest(REMOVE_FROM_SENDING_MESSAGES, removeFromSendingMessagesStart);
  yield takeLatest(HANDLE_SENDING_MESSAGES_TO_PUSHER, handleSendingMessagesToPusher);
  yield takeEvery(HANDLE_SENDING_COOKIES_TO_PUSHER, handleSendingMessagesToPusher);
  yield takeLatest(UPDATE_MESSAGE_READ_STATUS, updateMessageReadStatus);
  yield takeLatest(UPDATE_MESSAGE_DELIVERED, updateMessageDelivered);
  yield takeLeading(SET_TIME_SPENT.START, setTimeSpent);
  yield takeLatest(SET_ACTIVE_PAGE.START, setActivePage);
  yield takeLatest(HANDLE_WIDGET_EVENT, handleWidgetEvent);
  yield takeLatest(FETCH_MEETING_SLOTS, fetchMeetingSlotsSaga);
  yield takeLatest(BOOK_MEETING_SLOT, bookMeetingSlotsSaga);
  yield takeLatest(GET_ALL_FILES.START, getAllFiles);
  yield takeLatest(GET_RECENT_GIFS.START, getRecentGifsSaga);
  yield takeLatest(GET_TRENDING_GIFS.START, getTrendingGifsSaga);
  yield takeLatest(GET_SEARCHED_GIFS.START, getSearchedGifsSaga);
}